import { render } from "./EnbFrete.vue?vue&type=template&id=e9a2ac20&scoped=true"
import script from "./EnbFrete.vue?vue&type=script&lang=js"
export * from "./EnbFrete.vue?vue&type=script&lang=js"

import "./EnbFrete.vue?vue&type=style&index=0&id=e9a2ac20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a2ac20"]])

export default __exports__